import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CurrentInhibitionInfosPage } from 'src/swagger-gen/gnvert-secured/models/current-inhibition-infos-page';
import { BaseService } from '../services/base.service';
import { GetCurrentInhibitions$Params } from 'src/swagger-gen/gnvert-secured/fn/alarms/get-current-inhibitions';

@Injectable({
  providedIn: "root",
})
export class InhibitionRepo extends BaseService {
  private readonly baseUrl = environment.apiUrl;
  
  constructor(
    private readonly http: HttpClient
  ) {
    super();
  }

  /**
   * Returns list of all inhibitions
   */
  getInhibitions(
    params: GetCurrentInhibitions$Params
  ): Observable<CurrentInhibitionInfosPage> {
    const __params = new HttpParams()
      .set("offset", params.offset?.toString() as string)
      .set("limit", params.limit?.toString() as string);

    return this.http.get<CurrentInhibitionInfosPage>(
      `${this.baseUrl}/custom/alarms/inhibitions/current`,
      {
        headers: this.httpHeaders(),
        params: __params,
      }
    );
  }
}
